import React, { createContext, useState, useContext, ReactNode, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

interface FilterParams {
  [key: string]: any;
}

interface FilterContextType {
  filterParams: FilterParams;
  setFilterParams: React.Dispatch<React.SetStateAction<FilterParams>>;
  clearFilterParams: () => void;
}

const FilterContext = createContext<FilterContextType | undefined>(undefined);

const FilterProvider = ({ children }: { children: ReactNode }) => {
  const [filterParams, setFilterParams] = useState<FilterParams>({});
  const navigate = useNavigate();

  const clearFilterParams = () => {
    setFilterParams({});
  };

  return (
    <FilterContext.Provider value={{ filterParams, setFilterParams, clearFilterParams }}>
      {children}
    </FilterContext.Provider>
  );
};

const useFilter = (): FilterContextType => {
  const context = useContext(FilterContext);
  if (!context) {
    throw new Error('useFilter must be used within a FilterProvider');
  }
  return context;
};



export { FilterProvider, useFilter };
